import * as _ from 'lodash-es'
import { Box, Spinner } from '@chakra-ui/react'
import Link from 'next/link'
import { Simple1Grid } from './Chakra3F/ChakraF.jsx'
export { Simple1Grid }

export const TileLink = (/** @type {any} */ {pathname, query, name, comp, color, bg, onClick, loading}) => {

  const cursor = (pathname || onClick) && 'pointer'

  return <Box {...{rounded: 'sm', onClick, margin: 1, textAlign: 'center', fontSize: {base: '3xl'}, cursor, color, bg, as: pathname ? Link : undefined, href: pathname ? {pathname, query}: undefined}}>
    {comp || name}
    {loading && <>&nbsp;<Spinner /></>}
  </Box>
}

export const TileLinks = (/** @type {any} */ {tileItems, backTile, ...props}) => {
  return <Simple1Grid {...{columns: 2, ...props}}>
    {tileItems.map((props) => {
      const {name} = props
      return <TileLink key={name} {...{...props}} />
    })}
  </Simple1Grid>
}



